export const scrollToFirstErrorElement = (
	container?: Element | null,
	selector = '.Mui-error'
): Element | null => {
	const errElement = (container ?? window.document).querySelector(selector);

	if (errElement) {
		errElement.scrollIntoView({ block: 'center', behavior: 'smooth' });
	}

	return errElement;
};
